import PropTypes from "prop-types";

/*
 * Definition-list card used for the three detail panels (address, carrier,
 * support). Rows with no value are dropped so a sparse order never renders
 * a column of empty labels.
 */
export const InfoRow = ({ label, value }) =>
  value === null || value === undefined || value === "" ? null : (
    <div className="c4trk__row">
      <dt>{label}</dt>
      <dd>{value}</dd>
    </div>
  );

InfoRow.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.node,
};

const InfoPanel = ({ title, children, footer }) => (
  <section className="c4trk__panel">
    <h3 className="c4trk__panel-title">{title}</h3>
    <dl className="c4trk__rows">{children}</dl>
    {footer ? <div className="c4trk__panel-foot">{footer}</div> : null}
  </section>
);

InfoPanel.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  footer: PropTypes.node,
};

export default InfoPanel;
